<template>
  <div class="certificate-box">
    <p class="certificate-title">会员类型：{{lvl}}</p>
    <p class="certificate-title">证书编号：{{certNo}}</p>
    <img :src="certFile" alt="" class="certificate-img">
    <p class="certificate-tips">长按证书图片保存到手机</p>
  </div>
</template>

<script>
  export default {
    name: "Certificate",
    data() {
      return {
        lvl: '',
        certNo: '',
        certFile: ''
      }
    },
    created() {
      this.init()
      this.lvl = this.$store.state.user.lvlName
    },
    methods: {
      init() {
        this.$api.apiContent.getUser({
          token: this.$store.state.user.token
        }).then(res => {
          this.certNo = res.row.certNo
          this.certFile = res.row.certFile
        }).catch(e => {
          console.log(e)
        })
      },
    }
  }
</script>

<style scoped lang="scss">
.certificate-box{
  padding: 30px 20px;
  .certificate-title{
    font-size: 20px;
    line-height: 30px;
  }
  .certificate-img{
    display: block;
    width: 100%;
    margin: 30px auto;
  }
  .certificate-tips{
    text-align: center;
  }
}
</style>